import { fetch } from "../lib/network";
import AppSettings from "../config";

export const getUserPreferences = (networkHeaders: any) => () =>
  fetch(`${AppSettings.IDENTITY_API_URL}/me/preferences`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const patchUserPreferences = (networkHeaders: any) => {
  return ({ key, value }: { key: string; value: string }) =>
    fetch(`${AppSettings.IDENTITY_API_URL}/me/preferences/${key}`, {
      method: "PATCH",
      headers: networkHeaders,
      body: JSON.stringify({ value }),
    });
};
